export const MENUS_REQUEST_ACTONS_MAPPING = {
  outToDoProcess: 'toDoProcess',
  outCompletedProcess: 'completedProcess',
};

export enum NodeEnum {
  /**
   * 待竞选
   */
  AWAITING_BIDDING = 'awaiting_bidding',
  /**
   * 待提交标书
   */
  AWAITING_SUBMISSION_BIDS = 'awaiting_submission_bids',
  /**
   * 关闭
   */
  CLOSED = 'closed',
}

export const getListPathMenuKey = () => {
  let listMenu = '';
  const hashStr = location.hash;
  // @ts-ignore
  const [_1, _2, subPath] = hashStr.split('/');
  if (subPath) {
    const [listMenuKey] = subPath.split('?');
    if (listMenuKey) {
      listMenu = MENUS_REQUEST_ACTONS_MAPPING[listMenuKey];
    }
  }
  return listMenu;
};
